<template>
<header>


  <router-link to="/" class="logo"><img src="/static/lizard.png" alt=""></router-link>

  <div v-if="loggedIn" @click="addActive" class="nav-button">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>


  <div class="page-title">{{$parent.activePage}}</div>


  <div v-if="loggedIn" @click="$router.push('inbox')" class="notifications">3</div>

  <div class="header-navigation hide-mobile">
    <!-- <a href="tel:2086997404"><li class="conversion-button">Schedule Appointment</li></a> -->
<!-- 
    <ul>
      <li><a href="timeline">Dental Timeline</a></li>
      <li><a href="messages">Messages</a></li>
      <li><a href="dental-rader">Dental Radar</a></li>
      <li><a href="report-problem">Report Problem</a></li>
      <li><a href="dentist-profile">Dentist Profile</a></li>
    </ul> -->
  </div>

  <section :class="{navigation: activeNav}" class="container page">
      <!-- <h1 v-if="isLoggedIn"> {{ currentUser }}</h1> -->
    <ul>
      <li><router-link to="timeline">Dental Timeline</router-link></li>
      <li><router-link to="inbox">Inbox</router-link></li>
      <li><router-link to="dental-radar">Dental Radar</router-link></li>
      <li><router-link to="report-problem">Report Problem</router-link></li>
      <li><router-link to="dentist-profile">Dentist Profile</router-link></li>
    </ul>
    
    <!-- <div @click="$router.push('/settings')" class="settings">
      <img src="/static/Settings.svg">
    </div> -->
      <div @click="logout" class="settings">
      <img src="/static/Settings.svg">
    </div>

  </section>
    <!-- <div v-if="loggedIn" class="user-name">{{userData.displayName}}</div> -->


</header>

</template>

<script>
import AOS from '../main'
import { firestore } from "../main";
import * as firebase from "firebase";
import { mapMutations, mapGetters } from 'vuex'
import { userInfo } from 'os';


export default {
  name: 'header',
  data () {
    return {
      activeNav: false,
      isLoggedIn: false,
      currentUser: false,
      photoUrl: '',
      displayName: '',
      email: '',
      searchHidden: false,
      errorClass: 'errorClass',
      searchExpand: 'searchExpand',
      users: '',
      userData: {},
      query: ''
    }
  },

  methods: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ]),
    addActive() {
      this.activeNav = !this.activeNav
    },
      logout: function (e) {
        this.$store.commit('logOut');
    },

  },
    firestore() {
    return {
      userData: firestore.collection('users').doc(this.user.uid),
    }
  },
    computed: {
    getState() {
      return this.$store.state;
    },
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading'
    ])
  }
}
</script>

<style scoped lang="scss">

$brandColor: #29aad0;
$brandColorTwo: #70c8df;
$brandColorThree: #8fe9ff;
$accentColor: #de7c5e;

.user-name {
  position: fixed;
  background-color: $accentColor;
  color: white;
  padding: 3px 0;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 16px;
}

.nav-button {
  position: fixed;
  top: 8px;
  left: 10px;
  width: 40px;
  z-index: 9999999;
  text-align: center;
  padding: 0 5px 5px 5px;

}
.nav-button .line {
  width: 80%;
  height: 2px;
  background-color: $brandColor;
  margin: 7px;
}
.bgWhite {
  background-color: #fff !important;
}

.notifications {
  border: 1px solid $accentColor;
  border-radius: 50%;
  color: $accentColor;
  font-weight: 500;
  width: 25px;
  height: 25px;
  position: absolute;
  right: 25px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
// .nav-button .line:nth-child(1) {
//   width: 90%;
// }
// .nav-button .line:nth-child(2) {
//   width: 70%;
// }
// .nav-button .line:nth-child(3) {
//   width: 40%;
// }
// .nav-button .line:nth-child(4) {
//   width: 60%;
// }

header {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 1px 1px 5px rgb(195, 202, 211);
  color: #000;
  height: 50px;
  position: fixed;
  top: 0;
  z-index: 9999999;
  transition: all .1s ease-in-out;
  
}
input[type="text"],
input[type="date"],
input[type="datetime"],
input[type="email"],
input[type="number"],
input[type="search"],
input[type="time"],
input[type="url"],
input[type="password"],
textarea,
select {
    position: absolute;
    top: 8px;
    right: 1.5em;
    font-family: "avenir", sans-serif;
    text-transform: lowercase;
    letter-spacing: 2px;
    background: #FFF;
    border-style: none;
    box-shadow: 3px 3px 3px #eee;
    border-radius: 25px;
    font-size: 16px;
    margin: 0;
    outline: 0;
    width: 0;
    padding: 12px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    text-align: center;
    margin-bottom: 15px;
    transition: all 0.25s ease-in-out;
    cursor: pointer;

}
input[type="text"].searchExpand {
  width: 30%;
  padding: 12px 7px;
}

.button {
  margin: 0 10px;
  width: auto;
  height: auto;
  padding: 8px 55px;
  display: inline-block;
  color: #111;
  border: 1px solid #333;
  font-weight: bold;
}
.conversion-button {
  color: #fff;
  padding: 7px 15px;
  border: 1px solid #fff;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  margin: 0 2em;
  height: 40px;

    &:hover{
      border-color: #fff;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #fff;
    }
}
.sign-in {
  position: absolute;
  top: 10px;
  left: 15px;
}
.logo {
  top: 0;
  left: 0;
  width: 250px;
  height: 1px;
  border-bottom: 70px solid #c1e529;
  border-right: 25px solid transparent;
  position: absolute;
  z-index: 999;
  display: none;
}
.logo img {
  top: 5px;
  left: 50px;
  height: 60px;
  width: auto;
  position: absolute;
}
.search-icon {
  right: 30px;
  top: 5px;
  width: 50px;
  position: absolute;
}

.search {
  padding: 5px 20px;
  border-radius: 20px;
  font-family: 1.2em;
  font-family: Georgia;
  background: white;
  line-height: 3;
  border: none;
  position: absolute;
  top: 12px;
  right: 20px;
  width: 300px;
  transition: .2s ease-in-out;
  font-family: "source sans pro";
  letter-spacing: 0.1em;
  display: none;
}
.search:focus {
    background-color: #EEEEEE;
    border: none;
    outline: none;
    color: #111;
}

#user-image {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  /* border: 2px solid #323232; */
  position: absolute;
  top: 15px;
  left: 30px;
  background-size: contain;
}
.beta {
  color: #fff;
  display: inline-block;
  font-family: 'avenir', sans-serif;
  font-weight: 300;
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 0.4em;
  width: 100%;
  position: fixed;
  top: 65px;
  left: 0;
  background-color: #333;
  text-align: left;
  padding: 5px 0 5px 1em;
  display: none;
  /* position: absolute;
  left: 4em; */
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
  height: inherit;
}
li {
  display: flex;
  align-items: center;
  height: inherit;
  transition: background-color .3s ease-in-out;
}

.navigation {
  width: 100% !important;
}
.header-navigation {
  position: relative;
  float: right;
  height: 100%;
  margin: 0;
}
.header-navigation ul{
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.header-navigation ul li{
  letter-spacing: 1px;
  font-family:'Avenir', sans-serif;
  padding: 0 2em;

}


a {
  text-decoration: none;
  cursor: pointer;
  transition: color .25s ease-in-out;

    &:hover {
      color: #fff;
      border-bottom: 1px solid #fff;
    }
}

.social-group a img{
  width: 20px;
  display: block;
}

.container {
  transition: .3s ease-in-out;
  margin: 0 auto 0 auto;
  padding: 0;
  height: 100%;
  width: 0;
  overflow: hidden;
  position: fixed;
  background-image: linear-gradient(to bottom right, $brandColor, $brandColorTwo);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 0;
    .settings {
      position: absolute;
      width: 35px;
      height: 35px;
      left: 20px;
      bottom: 70px;
      // background-color: red;
      // z-index: 999999;
      img {
        width: 100%;
      }
    }

    ul {
    text-align: left;
      list-style-type: none;
      padding: 0;
      height: 100%;  
      width: 100%;
      left: 0;
      top: 100px;
      position: absolute;
      text-align: center;
    li {
      text-decoration: none;
      height: 50px;
      list-style: none;
      margin: 1em auto;
      border: none;
      color: #fff;
      font-family: 'Avenir', sans-serif;
      font-weight: 100;
      font-size: 20px;
      width: inherit;
      a {
        margin: 0 auto;
        border-bottom: 1px solid #fff;
        padding-bottom: 20px;
        width: 200px;
      }
    }
  }
}


.container fieldset{
    border: none;
}
.container legend {
    font-size: 1.4em;
    margin-bottom: 10px;
}
.container label {
    display: block;
    margin-bottom: 8px;
}
.container input[type="text"],
.container input[type="date"],
.container input[type="datetime"],
.container input[type="email"],
.container input[type="number"],
.container input[type="search"],
.container input[type="time"],
.container input[type="url"],
.container input[type="password"],
.container textarea,
.container select {
    font-family: "source sans pro", sans-serif;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: bold;
    /* background: #E5E5E5; */
    border: none;
    border-radius: 4px;
    font-size: 1em;
    margin: 0;
    outline: 0;
    padding: 25px 7px;
    width: 90%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    /* background-color: #e8eeef; */
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    margin-bottom: 15px;
    cursor: pointer;


}
.container input[type="text"]:focus,
.container input[type="date"]:focus,
.container input[type="datetime"]:focus,
.container input[type="email"]:focus,
.container input[type="number"]:focus,
.container input[type="search"]:focus,
.container input[type="time"]:focus,
.container input[type="url"]:focus,
.container input[type="password"]:focus,
.container textarea:focus,
.container select:focus{
    background: #FFF;
}
.container select{
    -webkit-appearance: menulist-button;
    height:35px;
}
/* .container .number {
    background: #1abc9c;
    color: #fff;
    height: 30px;
    width: 30px;
    display: inline-block;
    font-size: 0.8em;
    margin-right: 4px;
    line-height: 30px;
    text-align: center;
    text-shadow: 0 1px 0 rgba(255,255,255,0.2);
    border-radius: 15px 15px 15px 0px;
} */
.out-link  {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: "source sans pro", "avenir", sans-serif;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: lighter;
  border: none;
  border-radius: 4px;
  font-size: 1.2em;
  margin: 0 auto;
  outline: 0;
  padding: 20px 7px;
  width: 70%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  background-color: unset;
  color: #fff;
  text-align: right;
  transition: all .5s ease-in-out;
  text-decoration: none;
  display: block;
}
.container input[type="submit"],
.container input[type="button"]
{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: "source sans pro", "avenir", sans-serif;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: lighter;
  border: none;
  border-radius: 4px;
  font-size: 1.2em;
  margin: 0 auto;
  outline: 0;
  padding: 20px 7px;
  width: 70%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  background-color: unset;
  color: #fff;
  text-align: right;
  transition: all .5s ease-in-out;
  cursor: pointer;

}
.container input[type="submit"]:hover,
.container input[type="button"]:hover
{
    color: #999;
}

@media only screen and (max-width: 900px) {

  .button {
    margin: 5px 10px;
    width: auto;
    height: auto;
    padding: 8px 55px;
    display: inline-block;
    /* background-color: #333; */
    color: #111;
    border: 1px solid #333;
    font-weight: bold;
    display: none;
  }

  .conversion-button {
    background-color: #eee;
    border: 3px solid #111;
    display: block;
    color: #333;
    font-size: 12px;
    padding: 8px 20px;
    border-radius: 50px;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue